/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalySummaryRequest {
    getFixupPrototypeFunction() { return CostAnomalySummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalySummaryRequest>): CostAnomalySummaryRequest {
        let obj = Object.assign(new CostAnomalySummaryRequest(), model);
        CostAnomalySummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalySummaryRequest>): CostAnomalySummaryRequest {
        if (!model) return null;
        return CostAnomalySummaryRequest.newInstance(<CostAnomalySummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalySummaryRequest) {
        if (!obj) return;

        models.CostAnomalySummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalySummaryRequest): boolean {
        Object.setPrototypeOf(obj, CostAnomalySummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Service Account IDs
     */
    service_account_ids: Array<string>;

    /**
     * Query expression to filter line items
     */
    filters: models.QueryOperator;

    /**
     * specify the start date
     */
    start_date: Date;

    /**
     * specify the end date
     */
    end_date: Date;

    /**
     * Required Anomaly status
     */
    anomaly_status: models.AnomalyStatus;

    /**
     * Optional timezone of the caller
     */
    time_zone: string;

    /**
     * Records based on the actual metric that is used during anomaly detection
     */
    billing_source: string;

}
